<script>


import {redirectToUConnect} from "../../../helpers/routerHelper";
import RequestAgentKitDialog from "../../common/requestAgentKitDialog.vue";

export default {
  name: "uConnectRegistrationSection4",
  data() {
    return {
      requestAgentDialogVisible: false
    };
  },
  methods: {
    redirectToUConnect,
    joinUConnect() {
      scroll(0, 0);
    },
  },
  components: { RequestAgentKitDialog}

}
</script>

<template>
  <div class="cta-section">
    <el-row class="cta-section-inner">
      <el-col :span="24">
        <!-- Main CTA Section -->
        <div class="cta-main">
          <h2 class="cta-title">Collaborate in a Powerful Professional Network</h2>
          <p class="cta-description">
            U-Connect isn’t just a platform; it’s a professional ecosystem where industry experts come together to make deals happen. As a
            U-Connect member, you’ll have direct access to real estate agents, buyer’s agents, finance experts, accountants, and migration
            agents who are ready to work together to deliver client satisfaction.
          </p>
        </div>
        <!-- Main CTA Section -->
        <div class="cta-main">
<!--          <h2 class="cta-title">Platform Benefits for U-Connect Members:</h2>-->

          <el-row :gutter="20" style="padding-left: 20px; display: flex; justify-content: center">
<!--            <ul>-->
<!--              <li class="cta-description">-->
<!--                <b>Seamless Stock list Access:</b> Browse a comprehensive, organised list of properties-->
<!--                specifically curated for off-the-plan and new-build clients, enabling you to find the right opportunities quickly.-->
<!--              </li>-->
<!--              <li class="cta-description">-->
<!--                <b>Professional Collaboration:</b> Work alongside a trusted network of real estate and related professionals,-->
<!--                all committed to closing the best deals for clients.-->
<!--              </li>-->
<!--              <li class="cta-description">-->
<!--                <b>Enhanced Client Service:</b> Provide your clients with a streamlined path to property ownership, investment,-->
<!--                or relocation, backed by a professional team that covers all aspects of the process.-->
<!--              </li>-->
<!--            </ul>-->

            <div style="width:100%;height:300px;">
              <img src="../../../assets/platformBenefits.png" alt="img" style="width: 100%; height: 100%; object-fit: contain">
            </div>

          </el-row>

        </div>
        <!-- Secondary CTA Section -->
        <div class="cta-secondary">
          <p class="secondary-description">
            Join U-Connect and experience the benefits of a platform designed to help you grow your business,
            serve your clients, and access a world of property opportunities.
            Connect with professionals, close more deals, and elevate your career with U-Connect today.
          </p>
        </div>
      </el-col>
    </el-row>
    <div class="button-group">
      <el-row :gutter="30">
        <el-col :span="12">
          <el-button
            type="primary"
            size="large"
            class="sign-in-btn"
            @click="redirectToUConnect"
          >
            SIGN IN
          </el-button>
        </el-col>
        <el-col   :span="12">
          <el-button
            type="primary"
            size="large"
            class="join-btn"
            @click="joinUConnect()"
          >
            JOIN U-CONNECT
          </el-button>
        </el-col>
      </el-row>
    </div>
<!--    <request-agent-kit-dialog v-if="requestAgentDialogVisible" :request-agent-dialog-visible="requestAgentDialogVisible" @onClose="requestAgentDialogVisible = false" />-->
  </div>

</template>

<style scoped lang="scss">
.cta-section {
  padding: 20px 20px;
}
.cta-section-inner {
  padding: 0 20px;
}
.cta-main, .cta-secondary {
  text-align: left;
  margin-bottom: 40px;
}

.cta-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.cta-description {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 40px;
}

.secondary-title {
  color: #003333;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;
}

.secondary-description {
  color: #003333;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.button-group {

  gap: 20px;
  margin: 30px 20px;
}

.sign-in-btn, .join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 15px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/uConnectRegistrationSection4.vue